import { map, compose, get } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getProp, keyBy } from '@mews/fp';
import { createOptionsSelector, localizeText } from '@mews-commander/utils';
import { Country } from '@mews-commander/data-access';
import { ApplicationState } from '@mews-commander/types';
import { getCountries as getCountriesSelector } from '@mews-commander/core/legacy-globalization';

export const getCountries = compose(
    keyBy('code'),
    map((c) => ({
        code: c.code,
        name: localizeText(getCountryTextKey(c.code ?? '')),
        nativeLanguageCode: c.nativeLanguageCode,
    })),
    (state: ApplicationState) => getCountriesSelector(state) as Country[]
);

export const getCountryTextKey = (code: string) => `Country${code}` as Mews.TextKey;

const getCountry = createSelector(
    getCountries,
    getProp<string | null | undefined>()('countryCode'),
    // @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
    (countries, countryId) => (countryId != null ? countries[countryId] : undefined)
);

export const getCountryName = compose(get('name'), getCountry);
export const getNativeLanguageCodeByCountryCode = compose(get('nativeLanguageCode'), getCountry);

export const getCountryOptions = createOptionsSelector(getCountries, { value: 'code' });
